<script>
export default {
    name: "BoundaryError",
    props: ['title', 'message', 'stacktrace'],
}
</script>

<template>
    <div class="p-4">
        <h2 class="text-danger">⚠️ {{ title }}</h2>
        <p>{{ message }}</p>
        <pre class="stacktrace">{{ stacktrace }}</pre>
    </div>
</template>

<style scoped>
    .stacktrace {
        white-space: pre-wrap;
        width: 100%;
    }
</style>
